import { memo } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { ContextModalProps } from "@mantine/modals";
import { z } from "zod";

import { Button, Group, Stack, TextInput } from "@mantine/core";

import { useUpdateCustomViewMutation } from "modules/core/hooks/mutations/custom_views/useUpdateCustomViewMutation";

import { CustomView } from "modules/core/types/entities";

type EditCustomViewModalProps = ContextModalProps<{
  view: CustomView;
  onSubmit: (view: CustomView) => void;
}>;

const EditCustomViewModal = (props: EditCustomViewModalProps) => {
  const { id, context, innerProps } = props;

  const { mutate: updateView, isLoading: isUpdating } =
    useUpdateCustomViewMutation();

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<{ title: string }>({
    defaultValues: { title: innerProps.view.title || "" },
    resolver: zodResolver(
      z.object({
        title: z.string().min(1, "Title is required")
      })
    )
  });

  const submitHandler = (data: { title: string }) => {
    updateView(
      { id: innerProps.view.id, title: data.title },
      {
        onSuccess: () => {
          context.closeModal(id);
          innerProps.onSubmit({
            ...innerProps.view,
            title: data.title
          });
        }
      }
    );
  };

  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <Stack>
        <TextInput
          data-autofocus
          label="View Title"
          placeholder="View title..."
          {...register("title")}
          error={errors.title?.message}
          disabled={isUpdating}
        />

        <Group justify="flex-end">
          <Button
            variant="light"
            color="dark"
            size="xs"
            disabled={isUpdating}
            onClick={() => {
              context.closeModal(id);
            }}
          >
            Cancel
          </Button>

          <Button color="violet" type="submit" size="xs" loading={isUpdating}>
            Save
          </Button>
        </Group>
      </Stack>
    </form>
  );
};

export default memo(EditCustomViewModal);
